<template>
  <check-base-layout
    :show-mark="false"
    :pagetitle="pagetitle"
    :checkInfoData="checkFrom"
  >
    <template>
      <check-module :ishow-title="false">
        <el-link
          type="danger"
          :underline="false"
        ><i class="el-icon-warning-outline"></i>当前合同未满足发货条件，审批通过后将由仓储部门开始发货。
        </el-link>
      </check-module>
      <check-module :title="`合同总览`">
        <compart-module :compartData="checkFrom.orderContractBaseOtherPayVo"></compart-module>
      </check-module>
      <check-module
        :title="`付款周期`"
        :is-table="true"
      >
        <el-table
          :data="tableData"
          :header-cell-style="tableHeader"
          border
        >
          <el-table-column
            prop='payment'
            label="付款项"
          ></el-table-column>
          <el-table-column
            prop='amount'
            label="金额"
          >
            <template v-slot="{ row }">
              {{row.amount | toFixed}}
            </template>
          </el-table-column>
          <el-table-column
            prop='point'
            label="比例"
          >
            <template v-slot="{ row }">
              {{row.point | toPercentFormat}}
            </template>
          </el-table-column>
          <el-table-column
            prop='date'
            label="到期时间"
          >
            <template slot-scope="scope">{{scope.row.date}}</template>
          </el-table-column>
          <el-table-column
            prop='amountReceive'
            label="已划拨"
          >
            <template v-slot="{ row }">
              {{row.amountReceive | toFixed}}
            </template>
          </el-table-column>
        </el-table>
      </check-module>
      <check-module :title="`发货信息`">
        <el-row
          v-if="orderDeliverContentStockupVo.deliverMode === '客户自提'"
        >
          <el-col :span="8">
            <div class="">配送方式：{{orderDeliverContentStockupVo.deliverMode}}</div>
          </el-col>
          <el-col
            :span="8"
          >
            <div class="">提货人：{{orderDeliverContentStockupVo.expressConsignee}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">备注：{{orderDeliverContentStockupVo.expressMark}}</div>
          </el-col>
        </el-row>
        <el-row v-if="orderDeliverContentStockupVo.deliverMode !== '客户自提'">
          <el-col :span="8">
            <div class="pb20">配送方式：{{orderDeliverContentStockupVo.deliverMode}}</div>
          </el-col>

          <el-col v-show="orderDeliverContentStockupVo.deliverMode !== '仓库配送'" :span="8">
            <div class="pb20">物流费用：{{orderDeliverContentStockupVo.expressFeeType}}</div>
          </el-col>
          <el-col :span="8">
            <div style="padding-bottom: 20px;">备注：{{orderDeliverContentStockupVo.expressMark}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">发货方式：{{orderDeliverContentStockupVo.deliverSet}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">发货人：{{orderDeliverContentStockupVo.deliverPeople}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">联系电话：{{orderDeliverContentStockupVo.deliverPhone}}</div>
          </el-col>
          <el-col :span="8">
            <div class="pb20">收货人：{{orderDeliverContentStockupVo.receivePeople}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">联系电话：{{orderDeliverContentStockupVo.receivePhone}}</div>
          </el-col>
          <el-col :span="8">
            <div class="">收货地址：{{orderDeliverContentStockupVo.receiveAddress}}</div>
          </el-col>
        </el-row>
        <!--        <el-row>-->
        <!--          <el-col :span="8">-->
        <!--            <div class="pb20">发货方式：{{orderDeliverContentStockupVo.deliverSet}}</div>-->
        <!--          </el-col>-->
        <!--          <el-col :span="8">-->
        <!--            <div class="pb20">发货人：{{orderDeliverContentStockupVo.deliverPeople}}</div>-->
        <!--          </el-col>-->
        <!--          <el-col :span="8">-->
        <!--            <div class="pb20">联系电话：{{orderDeliverContentStockupVo.deliverPhone}}</div>-->
        <!--          </el-col>-->
        <!--        </el-row>-->
        <!--        <el-row>-->
        <!--          <el-col :span="8">-->
        <!--            <div class="">收货人：{{orderDeliverContentStockupVo.receivePeople}}</div>-->
        <!--          </el-col>-->
        <!--          <el-col :span="8">-->
        <!--            <div class="">联系电话：{{orderDeliverContentStockupVo.receivePhone}}</div>-->
        <!--          </el-col>-->
        <!--          <el-col :span="8">-->
        <!--            <div class="">收货地址：{{orderDeliverContentStockupVo.receiveAddress}}</div>-->
        <!--          </el-col>-->
        <!--        </el-row>-->
        <!--        <el-row v-if="orderDeliverContentStockupVo.deliverMode === '客户自提'">-->
        <!--          <el-col :span="8">-->
        <!--            <div style="padding-top: 20px;">备注：{{orderDeliverContentStockupVo.expressMark}}</div>-->
        <!--          </el-col>-->
        <!--        </el-row>-->
      </check-module>
      <check-module
        :tabsdata="tabsdata"
        :activeName="activeTabs"
        :is-table="true"
        @tabclick="tabclick"
      >
        <el-table
          :data="bTableData"
          :header-cell-style="tableHeader"
          :height="`300px`"
          border
        >
          <el-table-column
            prop='brandName'
            label="品牌"
          ></el-table-column>
          <el-table-column
            prop='seriesName'
            label="系列"
          ></el-table-column>
          <el-table-column
            prop='proName'
            label="产品名称"
          ></el-table-column>
          <el-table-column
            prop='proType'
            label="型号"
          ></el-table-column>
          <el-table-column
            prop='orderNumber'
            label="订货号"
          ></el-table-column>
          <el-table-column
            prop='cbUnit'
            label="单位"
          ></el-table-column>
          <el-table-column
            prop='count'
            label="数量"
          ></el-table-column>
          <!--          <el-table-column-->
          <!--            prop='cbExtype'-->
          <!--            label="类型"-->
          <!--          ></el-table-column>-->
          <el-table-column
            prop='obExtime'
            label="货期"
          >
            <template slot-scope="scope">
              {{scope.row.cbExtimeValue | formatterextion}}
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop='cbPrice'-->
          <!--            label="单品报价"-->
          <!--          >-->
          <!--            <template v-slot="{ row }">-->
          <!--              {{row.cbPrice | toFixed}}-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop='cbPrice'
            label="销售单价"
          >
            <template v-slot="{ row }">
              {{row.cbPrice | toFixed}}
            </template>
          </el-table-column>
          <el-table-column
            prop='cbRate'
            label="毛利率"
          >
            <template v-slot="{ row }">
              {{row.cbRate | toPercentFormat}}
            </template>
          </el-table-column>
          <el-table-column
            prop='cbUnitPrice'
            label="供货单价"
          >
            <template v-slot="{ row }">
              {{row.cbUnitPrice | toFixed}}
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop='purchaseUnitPrice'-->
          <!--            label="供货单价"-->
          <!--          >-->
          <!--            <template v-slot="{ row }">-->
          <!--              {{row.purchaseUnitPrice | toFixed}}-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            v-if="activeTabs === 'b'"
            prop='outDate'
            label="发货时间"
          >
            <template v-slot="{ row }">
              {{row.outDate | formatData}}
            </template>
          </el-table-column>
          <el-table-column
            v-if="activeTabs === 'b'"
            prop='deliverState'
            label="发货状态"
          >
            <template v-slot="{ row }">
              {{deliverStateex[row.deliverState]}}
            </template>
          </el-table-column>
        </el-table>
        <div class="allfield_title">总计</div>
        <info-table
          :field-arr="allFieldArr"
          :table-data="allTableData"
          :table-height="allTableData.length ? `73px` : 'auto'"
          :to-fixed-format="['cbPriceTotal','cbUnitTotal']"
        ></info-table>
      </check-module>
    </template>
    <template v-slot:checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :checkData="checkFrom.systemFlowRunAuditOrgVos"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { isSuccess } from '@/util/tool'
import { deepClone } from '@/util'
import { deliverStateex } from '@/meun/date'

export default {
  name: 'deliverCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '发货审批'
    }
  },
  data () {
    return {
      activeTabs: 'a',
      deliverStateex,
      allFieldArr: [
        //   {
        //   name: 'cbPriceTotal',
        //   label: '总报价'
        // },
        {
          name: 'cbPriceTotal',
          label: '销售总额'
        }, {
          name: 'cbUnitTotal',
          label: '供货总额'
        }],
      tabsdata: [
        {
          label: '发货清单',
          name: 'a'
        },
        {
          label: '历史发货',
          name: 'b'
        }
      ],
      historyListData: [],
      historyallData: {},
      checkFrom: {
        orderDeliverContentStockupVo: {}
      }
    }
  },
  filters: {
    formatterextion (val) {
      if (!val) return '--'
      const d = val.split('-')
      if (d.length !== 2) return val
      return val + '天'
    }
  },
  computed: {
    // 付款周期
    tableData () {
      return this.formatTableData(this.checkFrom.orderContractBasePayVoList)
    },
    // 发货清单  历史发货
    bTableData () {
      if (this.activeTabs === 'b') {
        return this.historyListData
      }
      return this.formatTableData(this.checkFrom.orderDeliverContentStockupVo.orderContentByDeliverCountVoList)
    },
    // 总计
    allTableData () {
      if (this.activeTabs === 'b') {
        return [this.historyallData]
      }
      return [this.checkFrom]
    },
    // 发货信息
    orderDeliverContentStockupVo () {
      return this.checkFrom.orderDeliverContentStockupVo
    }
  },
  mounted () {
    this.getDeliverCheckData()
  },
  methods: {
    getDeliverCheckData () {
      const {
        snaId
      } = this
      checkApi.deliverCheckInfo({
        snaId
      }).then(res => {
        if (isSuccess(res)) {
          this.checkFrom = deepClone(res.data.obj)
          this.$emit('update:data', deepClone(res.data.obj))
        }
      })
    },
    formatTableData (data) {
      if (!data) return []
      return Array.isArray(data) ? data : [data]
    },
    getDeliverHistory () {
      const {
        ocbId
      } = this.checkFrom.orderDeliverContentStockupVo
      checkApi.getDeliverHistory({
        ocbId
      }).then(res => {
        if (isSuccess(res)) {
          this.historyallData = res.data.obj
          this.historyListData = res.data.obj.orderContentByDeliverCountVoList
        }
      })
    },
    // tab切换
    tabclick (e) {
      this.activeTabs = e
      if (e === 'b') {
        this.getDeliverHistory()
      } else {
        this.getDeliverCheckData()
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>

<style
  scoped
  lang="less"
>
  /deep/ .el-icon-warning-outline {
    padding-right: 10px;
  }
</style>
